import { renderRichText } from '@storyblok/js';

export default function (data) {
  return {
    module: 'STile',
    ...data,
    imageMaxHeight: parseInt(data?.imageMaxHeight),
    imageSrc: data?.imageSrc?.filename,
    slots: {
      default: renderRichText(data?.content)
    }
  };
}
